import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { interaction_arrows_chevronLeft, interaction_arrows_chevronRight } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp, fRef } from '../../utils/React.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { IndicatorWrapper } from '../Indicator/IndicatorWrapper.js';
import { NavigationBarPresentation } from '../NavigationBar/NavigationBarPresentation.js';
import { hostClass } from './TabBar.styles.js';

var defaultProps = {
  onChange: function onChange() {
    /* empty */
  }
};
// Hack to get rid of forwardRefs
var Div = fRef(function (_a) {
  var ref = _a.ref,
    props = __rest(_a, ["ref"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  }));
});
var TabBarPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    className = props.className,
    noMargin = props.noMargin,
    innerRef = props.innerRef,
    offsetLeft = props.offsetLeft,
    showArrowLeft = props.showArrowLeft,
    showArrowRight = props.showArrowRight,
    value = props.value,
    onClickArrowLeft = props.onClickArrowLeft,
    onClickArrowRight = props.onClickArrowRight,
    centeredLayout = props.centeredLayout,
    restProps = __rest(props, ["id", "className", "noMargin", "innerRef", "offsetLeft", "showArrowLeft", "showArrowRight", "value", "onClickArrowLeft", "onClickArrowRight", "centeredLayout"]);
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "-centered-layout"), centeredLayout), _cleanupClassObject))
  }, showArrowLeft &&
  /*#__PURE__*/
  // TODO use IconLink here
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-arrow-left"), true)),
    onClick: onClickArrowLeft
  }, /*#__PURE__*/React.createElement(IconPresentation, {
    icon: interaction_arrows_chevronLeft,
    size: "small",
    noMargin: true,
    color: "secondary",
    title: ""
  })), showArrowRight &&
  /*#__PURE__*/
  // TODO use IconLink here
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-arrow-right"), true)),
    onClick: onClickArrowRight
  }, /*#__PURE__*/React.createElement(IconPresentation, {
    icon: interaction_arrows_chevronRight,
    size: "small",
    noMargin: true,
    color: "secondary",
    title: ""
  })), /*#__PURE__*/React.createElement(Div, {
    className: "".concat(hostClass, "-inner"),
    ref: innerRef,
    style: {
      marginLeft: offsetLeft ? "".concat(offsetLeft, "px") : 0
    }
  }, /*#__PURE__*/React.createElement(NavigationBarPresentation, Object.assign({
    value: value
  }, restProps)), /*#__PURE__*/React.createElement(IndicatorWrapper, {
    activeElement: props.activeElement
  })));
}, defaultProps);
TabBarPresentation.displayName = "TabBarPresentation";

export { TabBarPresentation };
